export default function({ state, commit, dispatch, rootState }) {
    commit('startLoadingAllProviders')
    return dispatch('get', {
        url: '/user/' + rootState.auth.id + '/provider'
    }, {
        root: true
    })
    .catch((error) => console.error('Error loading provider ', error))
    .finally(() => commit('finishLoadingAllProviders'))
}
